export default __webpack_public_path__ + "static/media/illustration-study-3-n-w.4c05016a.webp";